import { collection, doc, DocumentData, QuerySnapshot } from "firebase/firestore";
import { FireDoc } from "../types/util.types";
import { db } from "src/firebase";

export const fireStoreCollectionName = {
  chat_support: "chat_support",
  creditVouchers: "creditVouchers",
  students: "students",
  organizations: "organizations",
  sessions: "sessions",
  tutor: "tutors",
  users: "users",
};

export const mapDocsWithIdAndRef = <T extends DocumentData>(
  querySnapshot: QuerySnapshot<T>
): FireDoc<T>["DocWithIdAndRef"][] => {
  return querySnapshot.docs.map((docSnapshot) => ({
    id: docSnapshot.id,
    docRef: docSnapshot.ref,
    ...(docSnapshot.data() as T),
  }));
};

export const generateDocId = (collectionName: string) => doc(collection(db, collectionName)).id;
